import React from "react";
import { Table } from "reactstrap";
import { func, array } from "prop-types";

import LogsTableRow from "./logs-table-row";

const LogsTable = ({ logs, toggleDetails }) => {
  const rows = logs.map((entry) => (
    <LogsTableRow key={entry.id} log={entry} toggleDetails={toggleDetails} />
  ));

  return (
    <Table className="logs-table">
      <thead className="thead-light">
        <tr>
          <th className="pl-4">Action</th>
          <th className="pl-0">User</th>
          <th className="text-center">Type</th>
          <th>Date Created</th>
          <th className="text-center">Message</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
};

LogsTable.propTypes = {
  toggleDetails: func,
  logs: array,
};

export default LogsTable;



// WEBPACK FOOTER //
// ./src/features/log/components/logs-table/LogsTable.jsx